<template>
  <div class="tw-flex tw-gap-4 tw-items-center tw-w-full p-2 tw-rounded-md tw-border-violet-600 tw-border tw-border-solid">
    <textarea
      v-model="message"
      placeholder="Have any questions?"
      rows="5"
      :disabled="isDisabled"
      class="tw-grow tw-resize-none tw-border-0 tw-bg-transparent tw-py-1.5 tw-text-gray-900 tw-placeholder-text-gray-400 tw-focus:ring-0 tw-sm:text-sm tw-sm:leading-6"
      @keyup="checkEnter"
    />
    <o-button
      variant="primary"
      icon-pack="fa"
      icon-right="paper-plane"
      :disabled="isDisabled"
      @click="sendMessage"
    >
      Send
    </o-button>
  </div>
</template>


<script>
import { mapStores } from 'pinia';
import { useChatStore } from '@frontend/ui/stores/chatStore';
import { useCheckupStore } from '@frontend/ui/stores/checkupStore';


export default {
  name: 'ChatInputBox',
  components: { /* Subcomponents */ },
  props: ['isDisabled', 'disabledMessage'],
  data() {
    return { message: '' };
  },
  computed: {
    ...mapStores(useChatStore, useCheckupStore),
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  methods: {
    checkEnter(event) {
      if (event.key === 'Enter') {
        if (event.shiftKey) return;
        this.sendMessage();
      }
    },
    sendMessage() {
      if (!this.message) return;
      const portfolioID = this.checkupStore.portfolio?.id;
      const benchmarkID = this.checkupStore.benchmark?.id;
      this.chatStore.sendMessage({ text: this.message, role: 'user' }, portfolioID, benchmarkID);
      this.message = '';
    },
  },
};
</script>


<style scoped>
tooltip {
   width: 90%; /* or whatever width you prefer */
}
</style>
